/* US2028001 (SCP-2026-07-02-US2028001): the Tailwind base/utilities layer itself now
   comes from the shared ../styles/tailwind-shared.css import in App.ts (ARGUS PR #164
   CRITICAL — dedupes the layer that Vite previously emitted once per component). This
   file keeps only App's own rule; postcss-root-to-host still rewrites the shared
   import's :root token declarations onto :host so they resolve inside this shadow root
   (and cascade to child component shadow roots via inherited custom props). */
:host {
  display: contents;
}
